import type { SomeSchema } from './types'

// Conservative recursion detection without invoking shape getters or callbacks.

export function requiresCycleTracking(root: SomeSchema): boolean {
  const path = new Set<SomeSchema>()
  const visited = new Set<SomeSchema>()
  function visit(schema: SomeSchema): boolean {
    if (path.has(schema)) return true
    if (visited.has(schema)) return false
    path.add(schema)
    const def = schema._zod.def
    const children: SomeSchema[] = []
    for (const key of ['schema', 'element', 'keySchema', 'valueSchema', 'input', 'output']) {
      const child = Object.getOwnPropertyDescriptor(def, key)?.value as SomeSchema | undefined
      if (child?._zod) children.push(child)
    }
    const options = Object.getOwnPropertyDescriptor(def, 'options')?.value as SomeSchema[] | undefined
    if (Array.isArray(options)) children.push(...options)
    const shape = Object.getOwnPropertyDescriptor(def, 'shape')?.value as object | undefined
    if (Object.getOwnPropertyDescriptor(def, 'shape')?.get !== undefined) return true
    if (shape) for (const key of Reflect.ownKeys(shape)) {
      const descriptor = Object.getOwnPropertyDescriptor(shape, key)
      if (descriptor?.get !== undefined || descriptor?.set !== undefined) return true
      const child = descriptor?.value as SomeSchema | undefined
      if (child?._zod) children.push(child)
    }
    const cyclic = children.some(child => visit(child))
    path.delete(schema)
    visited.add(schema)
    return cyclic
  }
  return visit(root)
}
